import { render, staticRenderFns } from "./GDDGraphs.vue?vue&type=template&id=1d4dfae6&"
import script from "./GDDGraphs.vue?vue&type=script&lang=ts&"
export * from "./GDDGraphs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports